import { contractError } from './json.js';

export const GAMEPLAY_SEMANTICS = Object.freeze([
  'action.started', 'action.committed', 'action.rejected',
  'contact.entered', 'hit.landed', 'damage.applied',
  'projectile.spawned', 'projectile.bounced', 'projectile.expired',
  'score.changed', 'round.started', 'round.ended',
  'order.created', 'order.progressed', 'order.served', 'order.expired',
  'objective.changed', 'match.ended',
] as const);
export type GameplaySemantic = typeof GAMEPLAY_SEMANTICS[number];
export function validateGameplaySemantic(value: unknown): GameplaySemantic {
  const semantic = GAMEPLAY_SEMANTICS.find(s => s === value);
  if (!semantic) contractError('semantic', `unsupported gameplay semantic ${String(value)}`);
  return semantic;
}
